import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { pcRoutes } from '@/pc/router';
import { mobileRoutes } from '@/m/router';
import { h5Routes } from '@/h5/router';
import { isMobileUA, isWechatUA } from '@/utils/platform';

const routes = [...h5Routes, ...mobileRoutes, ...pcRoutes, { path: '/:pathMatch(.*)*', name: 'not-found', redirect: '/' }];
const router = createRouter({ history: createWebHistory(), routes, scrollBehavior: () => ({ top: 0 }) });

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.isLogin && !auth.fetchMeAttempted) { auth.fetchMeAttempted = true; await auth.fetchMe(); }
  if (to.path === '/') {
    if (!auth.isLogin) { if (isWechatUA() || isMobileUA()) return { name: 'h5-home' }; return true; }
    if (auth.user?.roleCode === 'customer') return { name: 'h5-customer-orders' };
    if (isMobileUA()) return { name: 'm-dashboard' };
    return auth.isSuperAdminMode ? { name: 'super-admin' } : { name: 'dashboard' };
  }
  if (to.meta.public || to.meta.h5Public) return true;
  if (!auth.isLogin) {
    if (to.path.startsWith('/h5/customer/orders')) return { name: 'h5-customer-login', query: { redirect: to.fullPath } };
    if (to.path.startsWith('/h5')) return { name: 'h5-home', query: { login: '1' } };
    if (to.path.startsWith('/m')) return { name: 'm-login', query: { redirect: to.fullPath } };
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  const permCodes = to.meta.permissions as string[] | undefined;
  const isMobile = to.path.startsWith('/m/');
  const fallbackHome = isMobile ? { name: 'm-dashboard' } : auth.isSuperAdminMode ? { name: 'super-admin' } : { name: 'dashboard' };
  if (permCodes?.length && !auth.hasAnyPermission(...permCodes)) return fallbackHome;
  const roles = to.meta.roles as string[] | undefined;
  if (roles?.length && !auth.hasAnyRole(...roles)) return fallbackHome;
  return true;
});

export default router;